module.exports = __webpack_public_path__ + "assets/img/cases1.a869ef81.png";